module.exports = __webpack_public_path__ + "media/icon/icon-mail-661eac7a.svg";